module.exports = __webpack_public_path__ + "static/media/CarryOn_Backpack_Arrows_iOS13.20a2cd43.usdz";